import { media, style } from "typestyle";
import colors from "../../styles/colors";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";

export const footer = style({
  flexShrink: 0,
});
export const hooplaPromotion = style(
  {
    backgroundColor: "rgba(229,231,235,1)",
    color: "black",
    display: "flex",
    justifyContent: "center",
    padding: "1.5rem",
    textAlign: "center",
    alignItems: "center",
    position: "relative",
    margin: "0 auto",

    $nest: {
      span: {
        zIndex: 1, // We need this because the svg renders above the span by default,
        marginLeft: "2px",
      },
      svg: {
        display: "none",
      },
      a: {
        color: "black",
        textDecoration: "none",
        $nest: {
          "&:hover": {
            color: colors.grey[600],
            textDecoration: "underline",
          },
        },
      },
    },
  },
  media(upFrom(mediaQueries.desktopSmall), {
    $nest: {
      svg: {
        display: "block",
      },
    },
  }),
);

export const promotionBackground = style({
  position: "absolute",
  left: 20,
});

export const wrapper = style({
  backgroundColor: colors.grey[100],
});

export const container = style(
  {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
  },
  media(mediaQueries.tablet, {
    maxWidth: 600,
    margin: "0 auto",
  }),

  media(upFrom(mediaQueries.desktopSmall), {
    padding: "1rem 1.25rem",
    margin: "0 auto",
    maxWidth: 1000,
  }),
);

export const logoAndLinks = style(
  {
    display: "flex",
    flexDirection: "column",
  },
  media(upFrom(mediaQueries.desktopSmall), {
    flexDirection: "row",
  }),
);

export const brand = style({
  display: "flex",
  flexDirection: "column",
  flex: 1,
});

export const box = style({ marginBottom: "1rem" });

export const checkoutsAndStuff = style(
  {
    borderTop: `1px solid rgba(0, 0, 0, 0.07)`,
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    paddingTop: 20,
  },
  media(upFrom(mediaQueries.tablet), {
    justifyContent: "space-between",
    flexDirection: "row-reverse",
  }),
);

export const links = style(
  {
    display: "flex",
    flexDirection: "column",
    fontSize: "0.9rem",
    lineHeight: "1.75rem",
    $nest: {
      "&>a": {
        display: "flex",
        alignItems: "center",
      },
      "&>a>*:first-child": {
        marginRight: "0.25rem",
        color: "rgba(0,0,0,0.4)",
      },
    },
  },
  media(upFrom(mediaQueries.tablet), {
    flexDirection: "row",
    $nest: {
      "& > a:not(:last-child)": {
        marginRight: 20,
      },
    },
  }),
);

export const hooplaInfo = style({
  color: colors.grey[600],
  fontSize: "0.9rem",
  flex: 1,
});

export const termsAndPrivacy = style({
  fontSize: "0.8rem",
  lineHeight: "1.25rem",
  color: colors.grey[600],
  marginBottom: "3rem",

  $nest: {
    a: {
      display: "block",
    },
  },
});

export const paymentMethods = style(
  {
    height: "fit-content",
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
    textAlign: "right",
    $nest: {
      "& > svg:not(:first-child)": {
        height: 25,
        width: "auto",
      },

      "& > a > svg": {
        height: 25,
        width: "auto",
      },

      "& > svg:first-child": {
        height: 25,
        width: "auto",
      },
    },
  },
  media(mediaQueries.mobile, {
    textAlign: "left",
  }),
);
